// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"262":"2145710f","581":"96725183"}[chunkId] + ".chunk.css";
};